import { Paperclip } from 'lucide-react';
import FilePreview from '@/components/FilePreview';

/**
 * The inline preview (if the file's type supports one) plus the download chip — always
 * both, since a preview never has enough fidelity to replace the real file. Shared by
 * the internal chat (ChatPanel.jsx) and the public embed widget (EmbedChat.jsx) — both
 * surfaces show the exact same file/attachment UI, just pointed at their own
 * respective download endpoint (`downloadUrl` is the caller's concern: `/api/agent/
 * files/:id` internally, `/api/embed/files/:id?key=...&agentKey=...` for embed).
 */
export default function MessageFile({ file, downloadUrl }) {
  if (!file) return null;
  return (
    <div className="mt-1 space-y-1">
      {file.preview && <FilePreview preview={file.preview} downloadUrl={downloadUrl} />}
      <a
        href={downloadUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded-md border border-[var(--app-border)] text-primary-600 hover:bg-[var(--app-border)]/20"
      >
        <Paperclip size={12} /> {file.filename}
      </a>
    </div>
  );
}
